import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  ConfirmationFormSchema,
  FormPayload,
  FormPayloadItem,
  FormStatuses,
} from '@cashier/cashier-model';

export interface ConfirmationFormState {
  status: FormStatuses;
  formPayload: FormPayload;
  formSchema: ConfirmationFormSchema | null;
}

export const CONFIRMATION_FORM_FEATURE_KEY = 'confirmationForm';

export const initialConfirmationFormState: ConfirmationFormState = {
  status: FormStatuses.INITIATED,
  formPayload: {},
  formSchema: null,
};

export const confirmationFormSlice = createSlice({
  name: CONFIRMATION_FORM_FEATURE_KEY,
  initialState: initialConfirmationFormState,
  reducers: {
    fillConfirmationForm: (
      state,
      action: PayloadAction<{
        schema: ConfirmationFormSchema;
        payload: FormPayload;
      }>,
    ) => {
      state.formSchema = action.payload.schema;
      state.formPayload = action.payload.payload;
      state.status = FormStatuses.READY;
    },
    updateConfirmationPayloadItem: (
      state,
      action: PayloadAction<{
        name: string;
        fieldPayload: FormPayloadItem;
      }>,
    ) => {
      const { name, fieldPayload: newPayload } = action.payload;

      const oldPayload = state.formPayload[name] || {};

      state.formPayload[name] = {
        ...oldPayload,
        ...newPayload,
      };
    },
    setConfirmationFormStatus: (state, action: PayloadAction<FormStatuses>) => {
      state.status = action.payload;
    },
  },
});

export const confirmationFormReducer = confirmationFormSlice.reducer;

export const {
  fillConfirmationForm,
  updateConfirmationPayloadItem,
  setConfirmationFormStatus,
} = confirmationFormSlice.actions;
